import { render, staticRenderFns } from "./AreaBox.vue?vue&type=template&id=9b4f62d8&scoped=true"
import script from "./AreaBox.vue?vue&type=script&lang=js"
export * from "./AreaBox.vue?vue&type=script&lang=js"
import style0 from "./AreaBox.vue?vue&type=style&index=0&id=9b4f62d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4f62d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b4f62d8')) {
      api.createRecord('9b4f62d8', component.options)
    } else {
      api.reload('9b4f62d8', component.options)
    }
    module.hot.accept("./AreaBox.vue?vue&type=template&id=9b4f62d8&scoped=true", function () {
      api.rerender('9b4f62d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hotpotModal/AreaBox.vue"
export default component.exports